import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n/i18n";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// --- PRIVERSTINIS SENO SERVICE WORKER IŠTRYNIMAS ---
// Šitas kodas suranda seną "zombį" naršyklėje ir jį ištrina.
// Tai panaikins "Unsupported MIME type" klaidą ir leis matyti naujausią versiją.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  }).catch(error => {
    // Klaidos ignoruojamos
  });

  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister();
      console.log("Senas ServiceWorker sėkmingai ištrintas!");
    }
  });
}